import { Member } from './Member';
import { EventDetails } from './EventDetails';
import { registerSchema } from './transform';

export class MemberDetails extends Member {
  EventDetails: EventDetails | null = null;
  PhotoId: number | null = null;
  PhotoUrl: string = '';
  Gender: string[] = [];
  InterestedIn: string[] = [];
  Languages: string[] = [];
  Ethnicity: string = '';
  TextField1: string = '';
  TextField2: string = '';
  TextField3: string = '';
  // SocialTags inherited from Member
  Relationship: string[] = [];
  LookingFor: string[] = [];
  Description: string = '';
  BodyTypesLiked: string[] = [];
  BodyPartsLiked: string[] = [];
  SexualInterests: string[] = [];
  MutualKinks: string[] = [];
  PostsCount: number = 0;
  FollowingCount: number = 0;
  FollowersCount: number = 0;
  IsBlocked: boolean = false;
  IsAdmin: boolean = false;
  JoinDate: Date | null = null;
  LastVisitedYouDate: Date | null = null;
  IsAuthorizedViewer: boolean = false;
  IsPrivateFolderUnlocked: boolean = false;
  /** Viewer is staff and not this member: the private folder opens on the website. */
  CanModerate: boolean = false;
  IsUnlockRequestPending: boolean = false;
  PublicPhotosCount: number = 0;
  PrivatePhotosCount: number = 0;
  HasWeightRecords: boolean = false;
  EventsCount: number = 0;
} 

registerSchema(MemberDetails, {
  JoinDate: 'date',
  LastConnectionDate: 'date',
  LastVisitedYouDate: 'date',
  EventDetails: EventDetails,
});